import Dialog from "ui/elements/dialog/Dialog";
import Template from "ui/Template";
import {i18n} from "ui/i18n";
import Form from "ui/elements/form/Form";
import importTypeView from 'ui/editor/dialogs/elements-picker/html/import-type.handlebars';

/**
 * @type {{SOURCE: number, REFERENCE: number}}
 */
export const TYPE = {
	SOURCE: 1,
	REFERENCE: 2
};

/**
 * @type {Template}
 */
let template = null;

/**
 * Import type dialog box
 */
export default class ImportType extends Dialog {
	/**
	 * Class Constructor
	 */
	constructor() {
		super({
			title: i18n('title.import-type'),
			buttons: [
				{
					caption: i18n('buttons.apply'),
					role: 'apply',
					icon: '/images/icons.svg#icon-svg-check'
				},
				{
					caption: i18n('buttons.close'),
					role: 'close'
				}
			]
		});

		if (template === null) {
			template = new Template(importTypeView);
		}

		/**
		 * @type {Form}
		 * @private
		 */
		this._form = null;

		/**
		 * @type {function(type:number):void}
		 * @private
		 */
		this._callback = (type) => {};

		this._buildForm();
	}

	/**
	 * Handles click by button
	 *
	 * @param {string} role
	 * @returns {void}
	 * @protected
	 */
	_handleButton(role) {
		super._handleButton(role);

		if (role === 'apply') {
			this._apply();
			this.destroy();
		}
	}

	/**
	 * Returns promise which will be resolved with the selected import type.
	 * See constants TYPE.*.
	 *
	 * @returns {Promise<number>}
	 */
	getResult() {
		return new Promise((r) => {
			this._callback = r;
		});
	}

	/**
	 * @private
	 */
	_apply() {
		this._callback(parseInt(this._form.getValues().type));
	}

	/**
	 * Builds import types selector
	 *
	 * @private
	 * @returns {void}
	 */
	_buildForm() {
		let el = template.createElement({});
		this._form = new Form({
			parent: el,
			onApply: this._apply.bind(this),
			values: {type: TYPE.REFERENCE},
			fields: [
				{
					type: 'radio',
					name: 'type',
					options: [
						{value: TYPE.REFERENCE, text: i18n('inputs.scene.import-types.reference')},
						{value: TYPE.SOURCE, text: i18n('inputs.scene.import-types.source')},
					],
					caption: i18n('inputs.scene.import-type'),
				}
			]
		});
		this.setContent(el);
	}
}
